import { AllianzEarningsReportEntity } from '../entities/allianz-earnings-report-entity';

export default class State {
  loaded = false;

  items: Array<AllianzEarningsReportEntity> = [];
}
